export default __webpack_public_path__ + "static/media/logo-dark.fb76c887.png";